<template>
  <div class="app-shell">
    <OfflineBanner />
    <router-view/>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import OfflineBanner from '@/components/OfflineBanner.vue';
import { initConnectivityListeners } from '@/utils/connectivity';

onMounted(() => {
  initConnectivityListeners();
  getAuth();
  onAuthStateChanged(getAuth(), () => {});
});
</script>

<style lang="scss">
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import 'assets/css/index.css';
    /* Auth + legal shells must be global: Terms/Privacy open in new tabs / cold refresh
       and otherwise miss login.css when it was only pulled in via Sign-In/Register chunks. */
    @import 'assets/css/login.css';
    @import 'assets/css/legal.css';
    /* Site UI: Inter + Poppins. Venue strip: Roboto (Binance/KuCoin fallback), IBM Plex Sans (Kraken fallback). */
    @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@600;700&family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&family=Roboto:wght@500;600;700&display=swap');
    @import url('https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css');
    @import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css');
</style>
